import * as React from "react";
import { useEffectWhenMounted } from "./useEffectWhenMounted.hook";

export const useScrollEffectWhenMounted = (elementsToWatchOutFor: any[]): React.MutableRefObject<HTMLDivElement> => {
    const listContainer = React.useRef<HTMLDivElement>(null);

    const scrollToBottom = () => { listContainer.current.scrollTop = listContainer.current.scrollHeight };

    useEffectWhenMounted(scrollToBottom, elementsToWatchOutFor);

    return listContainer;
};


// WEBPACK FOOTER //
// ./src/hooks/useScrollEffectWhenMounted.hook.ts